import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';

import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';

import { DistributionPromo } from 'app/views/campaign-3/models/campaign-3.model';
import { BasketService } from '../basket.service';
import { BasketPromo } from '../baskets.model';

@Component({
  selector: 'app-basket-promo-list',
  templateUrl: './basket-promo-list.component.html',
  styleUrls: ['./basket-promo-list.component.css'],
})
export class BasketPromoListComponent implements OnInit {

  @Input() departmentList: Array<any> = [];
  @Output() departmentListSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('promoListDetailKontable')
  kontableComponent: Campaign3KontableComponent;

  /* === TABLE CONFIG === */
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;

  /* === STATE === */
  basketId: string = '';

  breadcrumbs: Array<BreadCrumbModel> = [];
  actionStatusList: Array<{ label: string; value: string }> = [];
  scopeList: Array<{ label: string; value: string }> = [];

  translationsMap: { [key: string]: string } = {};

  showTable: boolean = false;
  showBreadCrumb: boolean = false;
  basketPromoList: BasketPromo[] = [];
  constructor(
    private notifyService: MessageService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public basketService: BasketService
  ) { }

  ngOnInit(): void {
    this.initBreadCrumbs();
    this.subscribeToRouteParams();
    this.loadFilterList();
  }

  /* ===================== DATA ===================== */

  private loadBasketPromos(basketCode: string): void {
    this.basketService.getActivePromos(basketCode).subscribe(
      res => {
        this.basketPromoList = res;
      },
      error => {
        console.error('Errore durante il caricamento delle promo del basket:', error);
        this.showErrorMessage(
          this.translateService.instant('common.generic_error')
        );
      }
    );
  }

  /* ===================== ROUTING ===================== */
  routeParams
  basketCode
  private subscribeToRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      this.basketId = params['basketId'];
      this.basketCode = params['basketCode'];
      if (this.basketId) {
        this.routeParams = this.basketId;
        this.loadBasketPromos(this.basketCode);
      }
    });
  }

  goToPromoDetail(row: DistributionPromo): void {
    const { id: promoId, campaign_id: campaignId } = row;

    if (!promoId || !campaignId) {
      console.error('Parametri mancanti per la navigazione promo', row);
      return;
    }

    const url = `/campaign-3/${campaignId}/promo/${promoId}`;
    this.router.navigate([url]);
  }

  /* ===================== UI ===================== */

  private initBreadCrumbs(): void {
    this.translateService.get([
      'breadCrumb.baskets_list',
      'breadCrumb.basketPromoList',
    ]).subscribe(translations => {
      this.breadcrumbs = [
        {
          code: 'bc1',
          description: translations['breadCrumb.baskets_list'],
          routerLink: '/baskets-list'
        },
        {
          code: 'bc2',
          description: translations['breadCrumb.basketPromoList'],
          routerLink: '/basket-promo-list'
        }
      ];
      this.showBreadCrumb = true;
    });
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    }
  }

  private loadFilterList(): void {
    this.translateService.get([
      'common.active',
      'common.inactive',
      'campaign.emission',
      'campaign.fruition'
    ]).subscribe(translations => {

      this.translationsMap = translations;

      this.actionStatusList = [
        { label: '', value: '' },
        { label: translations['common.active'], value: '1' },
        { label: translations['common.inactive'], value: '0' }
      ];

      this.scopeList = [
        { label: '', value: '' },
        { label: translations['campaign.emission'], value: 'E' },
        { label: translations['campaign.fruition'], value: 'F' }
      ];

      this.showTable = true;
    });
  }



  private showErrorMessage(message: string): void {
    console.warn(message);
  }


  onGoBack() {
    this.router.navigate(['/baskets-list'], {
      queryParams: { basketId: this.basketId }
    });
  }


  goToThePromo(row: BasketPromo) {

    const dominio = window.location.origin;
    const urlBasket = row.link_dettaglio;

    if (!urlBasket) {
      console.error('Parametri mancanti', row);
      return;
    }

    const completeUrl = dominio + urlBasket;

    window.open(completeUrl, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-promo-list/basket-promo-list.component.ts